import { useLanguage } from '../../hooks/useLanguage';

const ROOM_CONFIG = {
  room1: {
    metaKey: 'room1Meta',
    titleKey: 'room1Title',
    textKey: 'room1Text',
    images: {
      avif: ['/images/room/room1.jpg', '/images/room/fallback.jpg'],
      webp: ['/images/room/room1.jpg', '/images/room/fallback.jpg'],
      fallback: '/images/room/fallback.jpg',
    },
    alt: 'Organic structures',
  },
  room2: {
    metaKey: 'room2Meta',
    titleKey: 'room2Title',
    textKey: 'room2Text',
    images: {
      avif: ['/images/room/room2.jpg', '/images/room/fallback.jpg'],
      webp: ['/images/room/room2.jpg', '/images/room/fallback.jpg'],
      fallback: '/images/room/fallback.jpg',
    },
    alt: 'Transformation & Fluid Expression',
  },
  room3: {
    metaKey: 'room3Meta',
    titleKey: 'room3Title',
    textKey: 'room3Text',
    images: {
      avif: ['/images/room/room3.jpg', '/images/room/fallback.jpg'],
      webp: ['/images/room/room3.jpg', '/images/room/fallback.jpg'],
      fallback: '/images/room/fallback.jpg',
    },
    alt: 'Immersion hall',
  },
};

export const Room = ({ roomId }) => {
  const { t } = useLanguage();
  const config = ROOM_CONFIG[roomId];
  
  if (!config) return null;

  return (
    <section
      id={roomId}
      className="flex items-center min-h-screen px-6 py-20 room"
      role="region"
      aria-label={t(config.titleKey)}
    >
      <div className="container max-w-6xl mx-auto">
        <div className="grid items-center gap-8 p-8 card glass rounded-2xl md:p-12 md:grid-cols-2">
          <div className="space-y-6">
            <div className="text-[var(--accent)] text-sm font-semibold tracking-widest uppercase">
              {t(config.metaKey)}
            </div>
            <h2 className="text-3xl font-bold leading-tight font-syne md:text-4xl lg:text-5xl">
              {t(config.titleKey)}
            </h2>
            <p className="text-[var(--muted)] text-lg leading-relaxed max-w-lg">
              {t(config.textKey)}
            </p>
          </div>
          
          <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
            <picture>
              <source type="image/avif" srcSet={config.images.avif.join(', ')} />
              <source type="image/webp" srcSet={config.images.webp.join(', ')} />
              <img
                src={config.images.fallback}
                alt={config.alt}
                className="object-cover w-full h-full"
                loading="lazy"
                decoding="async"
              />
            </picture>
          </div>
        </div>
      </div>
    </section>
  );
};
